<template>
  <div class="resume-picker-container flex onboarding-block-wrapper">
    <img class="avatar" src="https://logo.wondercv.com/banners/rFXnEYEDDxKYuKX.png" alt="" />
    <div class="flex flex-col">
      <div class="onboarding-block-container resume-picker-container">
        <div class="onboarding-block-title">基于已有简历创建</div>
        <div class="block-sub-title">选择简历</div>
        <div class="picker-resume-wrapper relative">
          <div v-if="resume" class="absolute lang-label">{{ resume.lang | langFilter }}</div>
          <el-select
            v-model="resumeToken"
            placeholder="请选择简历"
            class="onboarding-picker-select"
            popper-class="onboarding-select-popper"
          >
            <el-option
              v-for="(item, index) in cvs"
              :key="index"
              :label="item.cv_name"
              :value="item.token"
            >
              <div>{{ item.cv_name }}</div>
              <div>{{ item.lang | langFilter }}</div>
            </el-option>
          </el-select>
        </div>
        <div class="block-sub-title">修改方向（单选）</div>
        <div class="optimization-list flex justify-between items-center">
          <PickerBtn
            v-for="(item, index) in optimizationList"
            :key="index"
            :text="item.title"
            :active="item.value === optimizationType"
            class="flex-1 flex justify-center items-center"
            @click="clickOptimizationItem(item)"
          >
          </PickerBtn>
        </div>
        <template v-if="optimizationType === 'lang'">
          <div class="block-sub-title" style="margin-top: 20px">选择语言</div>
          <PickerBtn
            :text="optionalLanguage === 'cn' ? '中文' : '英文'"
            style="width: 180px"
            class="flex justify-center items-center"
            active
          />
        </template>
        <template v-else-if="optimizationType === 'intention'">
          <div class="block-sub-title" style="margin-top: 20px">选择求职意向</div>
          <MultiLevelPicker
            class="multi-level-picker-container"
            :list="professionList"
            :active-value="activeValue"
            placeholder="请选择"
            @confirm="confirm"
          />
        </template>
      </div>
      <div class="flex justify-end btn-container">
        <OnboardingBtn
          text="上一步"
          type="plain"
          :width="106"
          style="margin-right: 16px"
          @clickBtn="prev"
        />
        <OnboardingBtn text="下一步" type="primary" :width="106" @clickBtn="next" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import OnboardingBtn from './OnboardingBtn.vue';
import MultiLevelPicker from './MultiLevelPicker.vue';
import PickerBtn from './PickerBtn.vue';
import { resumeOperationMixin } from '@/views/editor2025/mixins/resume-operation';
import { breakResumeMixin } from '../resume.mixin';
import { routerTo } from '@/assets/js/util';
import api from '@/api/index';

const optimizationList = [
  {
    title: '更换求职意向',
    value: 'intention',
  },
  {
    title: '更换简历语言',
    value: 'lang',
  },
  {
    title: '简历内容优化',
    value: 'content',
  },
];

export default {
  name: 'ResumePicker',
  mixins: [resumeOperationMixin, breakResumeMixin],
  components: {
    OnboardingBtn,
    MultiLevelPicker,
    PickerBtn,
  },
  props: {
    professionList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      resumeToken: '',
      optimizationList,
      optimizationType: '',
      activeValue: '',
    };
  },
  computed: {
    ...mapState('cv', ['cvs']),
    resume() {
      return this.cvs.find((item) => item.token === this.resumeToken);
    },
    list() {
      return this.cvs.filter((item) => item.can_editable);
    },
    optionalLanguage() {
      return this.resume.lang === 'cn' ? 'en' : 'cn';
    },
  },
  filters: {
    langFilter(value) {
      return value === 'cn' ? '中' : '英';
    },
  },
  methods: {
    prev() {
      this.$emit('prev');
    },
    async fetchResumeByIntention() {
      try {
        const res = await api.AI.createResumeByIntention({
          intention: this.activeValue,
          cv_token: this.resumeToken,
        });
        if (res.code === 1000) {
          routerTo(`/ai/resume/${res.data.cv_token}/preview`);
        } else if (res.code === 3001) {
          this.$emit('buyMember');
        } else if (res.code === 3000) {
          this.memberResumeLimit(res);
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async next() {
      try {
        let result = null;
        this.$emit('changeCreateResumeLoading', true);
        switch (this.optimizationType) {
          case 'intention':
            await this.fetchResumeByIntention();
            break;
          case 'lang':
            result = await this.clickTranslationResume({
              isCheckSaved: false,
              displayLoading: false,
              translationLang: this.optionalLanguage,
              resumeToken: this.resumeToken,
              toEditor: false,
            });
            break;
          case 'content':
            result = await this.copyResume({
              isCheckSaved: false,
              displayLoading: false,
              copyLang: this.resume?.lang,
              resumeToken: this.resumeToken,
              toEditor: false,
            });
            break;
        }
        if (result?.code === 1000) {
          routerTo(`/cvs/${result.data.basic_info.token}/editor`);
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$emit('changeCreateResumeLoading', false);
      }
    },
    clickOptimizationItem(item) {
      this.optimizationType = item.value;
    },
    confirm(value) {
      this.activeValue = value;
    },
  },
  mounted() {
    if (this.cvs?.length) this.resumeToken = this.cvs[0].token;
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/index.scss';
@import '../styles/component.scss';
@import '@/assets/css/mixins.scss';
.resume-picker-container {
  width: 620px;
  .onboarding-block-title {
    font-size: 16px;
    color: #fff;
    margin-bottom: 20px;
  }
  .block-sub-title {
    font-size: 12px;
    color: #9a9ca2;
    margin-bottom: 12px;
  }
  .picker-resume-wrapper {
    height: 40px;
    margin-bottom: 20px;
    .lang-label {
      @apply flex justify-center items-center;
      right: 44px;
      top: 50%;
      transform: translateY(-50%);
      width: 21px;
      height: 24px;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.16);
      font-size: 13px;
      color: #fff;
      z-index: 2;
    }
  }
  .optimization-list {
    gap: 20px;
  }
  .multi-level-picker-container {
    width: 100%;
    ::v-deep(.multi-level-content) {
      width: 100%;
    }
  }
  .btn-container {
    margin-top: 32px;
  }
}
</style>
<style lang="scss">
@import '../styles/index.scss';
</style>
